import UsuariosCuentaCorriente from "./UsuariosCuentaCorriente";
import { withRouter } from "react-router-dom";

export default withRouter(UsuariosCuentaCorriente);
